module.exports = __webpack_public_path__ + "static/img/part-value-hover.f4351e1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/part-value-hover.svg
// module id = n8D7
// module chunks = 7